
// Click controls, close,
function configVideoControls(video) {
  var videoPlayer = video.closest('.video-overlay');
  var vid = video[0];
  var controlsBar = videoPlayer.find('.video-controls');
  var controlsPause = videoPlayer.find('.video-control.pause');
  var closeVideoBtn = videoPlayer.find('.closeVideo');
  var muteVideo = videoPlayer.find('.video-control.mute');
  var captionsButton = videoPlayer.find('.video-control.captions');

  captionsButton.click ( function() {
    if (vid.textTracks[0].mode == 'showing') {
      captionsButton.ariaLabel = 'Show Captions';
      captionsButton.removeClass('captions-on');
      vid.textTracks[0].mode = 'hidden';
    } else {
      captionsButton.ariaLabel = 'Hide Captions';
      captionsButton.addClass('captions-on');
      vid.textTracks[0].mode = 'showing';
    }
  });
  muteVideo.click ( function() {
    if (vid.muted) {
      vid.muted = false;
      muteVideo.ariaLabel = 'Mute Video';
      muteVideo.removeClass('unmute');
    } else {
      vid.muted = true;
      muteVideo.ariaLabel = 'Unmute Video';
      muteVideo.addClass('unmute');
    }
  });
  controlsPause.click ( function() {
    if (vid.paused) {
      vid.play();
      controlsPause.ariaLabel = 'Pause Video';
      controlsPause.removeClass('unpause');
    } else {
      vid.pause();
      controlsPause.ariaLabel = 'Play Video';
      controlsPause.addClass('unpause');
    }
  });
  closeVideoBtn.click ( function() {
    closeVideoOverlay($('.video-overlay.active'));
  });
} // end configVideoControls




// Custom timeline
const configVideoTimeline = (video) => {
  var vid = video[0];
  const dur = vid.duration;
  const progress = document.querySelector('.progress');
  const timeline = document.querySelector('.timeline');
  const tRect = timeline.getBoundingClientRect();
  const ind = timeline.querySelector('.indicator');

  // Click to a point in the video
  progress.onclick = (e) => {
    vid.currentTime = vid.duration * ((e.x - tRect.left) / timeline.offsetWidth);
  };

  // Move the progress bar with the video
  const interval = setInterval(() => {
    const pos = vid.currentTime;
    if (vid.currentTime > dur - 0.05) {
      clearInterval(interval);
    }
    ind.style.left = `${100 * pos / dur}%`;
  }, 50);
};





// Click play
$('.video-overlay-btn').off().click(function(e) {
  var videoOverlay = $(this).siblings('.video-overlay');
  var video = videoOverlay.find('video');
  var videoObj = video[0];

  handleFixedElements('hide');
  videoOverlay.addClass('active');

  if( window.innerWidth <= desktopBreakPoint ) { // Mobile
    if (videoObj.requestFullscreen) {
      videoObj.requestFullscreen();
    } else if (videoObj.mozRequestFullScreen) {
      videoObj.mozRequestFullScreen();
    } else if (videoObj.webkitRequestFullscreen) {
      videoObj.webkitRequestFullscreen();
    } else if (videoObj.msRequestFullscreen) {
      videoObj.msRequestFullscreen();
    }
    // Check for when exits fullscreen
    videoObj.addEventListener('fullscreenchange', function() {
      if ( !videoOverlay.find('video')[0].paused ) { // If is playing
        closeVideoOverlay(videoOverlay);
      }
    }, false);
  }

  setTimeout( function() {
    if (!video.hasClass('init')) { // First time only
      videoInit(video);
    } else {
      videoPlay(video);
    }
  }, 500); // Modal transition time

  // Vid end naturally
  video.on('ended', function(){
    closeVideoOverlay($('.video-overlay.active'));
  });

});




// Init
function videoInit(video) {
  video[0].currentTime = 0;
  videoPlay(video);
  configVideoControls(video);
  video.addClass('init');
}


// Play
function videoPlay(video) {
  video.on('durationchange', function() {
    configVideoTimeline(video);
  });
  video[0].play();
  configVideoTimeline(video);
}


// Close
function closeVideoOverlay(videoOverlay) {
  if ( !videoOverlay.find('video')[0].paused ) { // If is playing
    videoOverlay.find('video')[0].pause();
  }
  if (document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement) {
    document.exitFullscreen();
  }
  videoOverlay.removeClass('active');
  handleFixedElements('show');
  setTimeout( function() {
    videoOverlay.find('video')[0].currentTime = 0; // Reset to start
    videoOverlay.find('.video-controls').find('.progress .indicator').css('left', 0); // Reset indicator position
    videoOverlay.find('.video-controls').find('.video-control.pause').removeClass('unpause'); // Reset play state
  }, 500); // Modal transition time
} // end closeVideoOverlay



// Press Esc
$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    if ($('.video-overlay.active').length) {
      closeVideoOverlay($('.video-overlay.active'));
    }
  }
});
